import PropTypes from 'prop-types';
import React from 'react';

import connectToStores from '../../../helpers/connectToStores';
import KeyGoStore from '../../../stores/KeyGoStore';

import BaseModal from '../../general/BaseModal';
import AbstractKeyGoRegistration, { getStateFromStores } from './keyGoRegistration/AbstractKeyGoRegistration';
import KeyGoRegistration from './keyGoRegistration/KeyGoRegistration';

@connectToStores([ KeyGoStore ], getStateFromStores)
class KeyGoRegistrationModal extends AbstractKeyGoRegistration {

    static propTypes = {
        onCancel: PropTypes.func
    };

    render () {
        const { onCancel } = this.props;

        return (
            <BaseModal
                onClose={ onCancel }
                hideClose={ this.props.paymentSucceeded }
                onContinue={ this.props.paymentSucceeded ? onCancel : this.handleKeyGoPay }
                continueText={ this.props.paymentSucceeded ? 'button.text.close' : 'account.smartcard.keygo.signupButton' }
                closeText='button.text.cancel'
                disableContinue={ this.isButtonDisabled }
                titleText='smartcardCTA.message.signup.keyGo'
                className="modal--med" >
                <KeyGoRegistration { ...this.keyGoRegistrationProps } />
                { this.renderRegistrationWarning()}
            </BaseModal>
        );
    }

}


export default KeyGoRegistrationModal;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/KeyGoRegistrationModal.js